import { 
    convertISOtoDate,
    to_system_date,
    get_default_date
} from 'utils/date';

import { 
    hide_loading, 
    set_placeholders, 
    get_cancel_text,
    get_tc_section
} from 'booking-widget/v2/common/util';
import { esc_html } from 'utils/strings';
import { get as get_cache } from 'utils/cache';
import { update_data_targets } from 'ui/data';

import { init as init_pikaday, 
        destroy as destroy_pikaday,
        get_datestring as datepicker_datestring
} from 'booking-widget/v2/widgets/datepicker';

import { STEPS, hide_fullscreen_modal } from 'booking-widget/v2/bw';
import { 
    PICKERS_TEMPLATE, 
    PICKERS_TEMPLATE_COMPACT,
} from 'booking-widget/v2/templates/search';
import { ICON_CHECKMARK, MODAL_TEMPLATE, CLOSEX_MODAL_TEMPLATE } from 'booking-widget/v2/templates/shared';

import { hide as hide_popup } from 'ui/popup';
import {
    init as setup_modal,
} from 'ui/modal';

import { 
    init as init_guestpicker, 
    get_guest_counts, 
    destroy_guestpicker,
    set_guest_counts,
    set_guestpicker_display
}
from 'booking-widget/v2/widgets/guestpicker';

let widget_el_data_id = '';

let selected_date = '';

const MIN_MOUNTED_HEIGHT_GP = 570;
const MIN_MOUNTED_HEIGHT_DP = 1080;
const MIN_MOUNTED_WINDOW_WIDTH = 1220;

/**
 * There are only 2 looks for the search widget:  non-compact and compact
 * The non-compact is the search that is normally shown within the page
 *   - on mobile, it will display the expanded guestpicker
 * The compact has two forms:
 *  - Normal - usually shown in the menu on desktop and at the bottom on mobile
 *  - Mounted - Mounted to the side of the page shows the expanded guestpicker and calendar
 */
export const load = (options, bw_events) => {
    let opts = $.extend(true, {
        search_header: '',
        start_time: false,
        adult: false,
        child: false,
        toddler: false,
        filter_tour_id: 0,
        tour_id: 0, // not used
        search_tag: false,
        is_charter: false,
        vessel_type: false,
        theme: '',
        compact_only_opts: {},
    }, (options || {}));


    const bw_el = hide_fullscreen_modal(opts.context_el);
    // just in case, hide loading
    hide_loading(bw_el, true);
    
    if (!opts.search_selector) {
        return;
    }
    let el = $(opts.search_selector);
    if (el.length == 0) {
        return;
    }
    el.empty();

    if (opts.theme) {
        el.addClass(opts.theme);
    }

    let widget_el = el;
    let body_el = $('body');
    let is_tour_specific = !!opts.filter_tour_id;
    let search_text = is_tour_specific ? 'Book Now' : 'Check Availability';
    let is_compact = (opts.theme == 'bw-compact');
    let is_mounted = is_compact && opts.compact_only_opts.is_mounted ? opts.compact_only_opts.is_mounted : false;
    let bwgp_id = opts.identifier + '-bwgp-widget';
    widget_el_data_id = opts.identifier;
    widget_el.attr('data-bw-id', opts.identifier);

    if (opts.search_header !== false) {
        if (opts.search_tag !== false) {
            opts.search_header = 'Book ' + opts.search_tag.name + ' Tours';
        }
        else if (opts.is_charter) {
            opts.search_header = 'Book your Private Charter Online';
        }
        else {
            opts.search_header = 'Book Your Adventure';
        }
    }

    let default_date = new Date();
    const default_dt = get_default_date(opts.utc_offset);
    default_date = to_system_date(default_dt);
    let start_time = opts.start_time ? opts.start_time : default_date;
    selected_date = start_time;
    
    const search_header = opts.search_header !== false ?  '<h3><strong>' + esc_html(opts.search_header) + '</h3></strong>' : '';
    const search_tpl = is_compact ? PICKERS_TEMPLATE_COMPACT : PICKERS_TEMPLATE;
    widget_el.append(set_placeholders(search_tpl, {
        search_header: search_header,
        bwgp_id: bwgp_id,
        widget_el_data_id: `[data-bw-id='${widget_el_data_id}']`,
        search_text: search_text,
        cancel_text: '',
    }));

    if (is_tour_specific) {
        widget_el.addClass('bw-tour-specific');
    }

    if (opts.is_charter) {
        widget_el.attr('data-charters', 1);
        if (!is_compact) {
            // no vessels when compact
            $('.bw-search', widget_el).addClass('bw-charters');
            if (opts.vessel_type) {
                const vessel_types = opts.vessel_type.split(',');
                $('input[name="vessel_type"]', widget_el).each(function() {
                    const is_checked = vessel_types.includes($(this).val());
                    $(this).prop('checked', is_checked);
                });
            }
        }
    }
    let datepicker_el           = $('.bw-pickers__picker--datepicker', widget_el);
    let datepicker_display_el   = $('.bw-pickers__datepicker-display', widget_el);
    let guestpicker_control_el  = $('.bw-pickers__picker--guestpicker', widget_el);
    let cancel_button_el        = $('.bw-pickers__picker--cancel-free', widget_el);
    let search_button_el        = $('.bw-pickers__btn-submit', widget_el);
    let cancel_full_text        = $('.bw-pickers__picker-col--cancel-free-full', widget_el);

    init_guestpicker({
        popup_id: bwgp_id,
        display_el: guestpicker_control_el,
        adult: opts.adult,
        child: opts.child,
        toddler: opts.toddler,
        tour_id: opts.filter_tour_id,
        is_raft_only: opts.is_raft_only,
        is_compact: is_compact,
        on_shown: function(popup_el, opener_el) {
            cancel_full_text.removeClass('bw-cancel-free-popup');
        },
        on_hidden: function(popup_el, guest_counts) {
            const other_popups = $('.bw-popup.bwgp-widget').not(popup_el);
            other_popups.each(function() {
                set_guest_counts($(this), guest_counts);
            })

            const other_displays = $('.bw-pickers__picker--guestpicker').not(guestpicker_control_el);
            other_displays.each(function() {
                let is_compact = other_displays.closest('.bw-search').parent().hasClass('bw-compact');
                set_guestpicker_display(guest_counts, $(this), is_compact)
            })
        }
    });

    const pikaday_options = {
        bound: !is_mounted,
        datepicker_el: datepicker_el, 
        utc_offset: opts.utc_offset,
        start_time: opts.start_time,
        margin_top: (is_compact ? '10px' : ''),
        beforeOnOpen: function() {
            body_el.addClass('bw-bwdp-showing');
            if (is_compact) {
                body_el.addClass('bw-bwdp-showing--compact');
            }
            cancel_full_text.removeClass('bw-cancel-free-popup');
        },
        onClose: function() {
            body_el.removeClass('bw-bwdp-showing bw-bwdp-showing--compact');

        },
        onInit: function(pikaday, opts) {
            if (start_time) {
                set_datepicker_display(datepicker_display_el, start_time);
            }
            else {
                set_datepicker_display(datepicker_display_el, false);
            }
        },
        onSelect: function(date) {
            set_datepicker_display(datepicker_display_el, to_system_date(date));
            // no feasible way to get other pikaday objects
            // set other dp displays
            $('.bw-pickers__datepicker-display').not(datepicker_display_el).each(function() {
                set_datepicker_display($(this), to_system_date(date));
            })
            selected_date = to_system_date(date);
            repopulate_cancel_text(opts, selected_date);

        },
        onDraw: function(pikaday) {
            const container = $(pikaday.el);
            if ($('.pika-bottom-text', container).length == 0) {
                $('.pika-lendar', container).append('<div class="pika-bottom-text"><span class="bw-icon--image">' + ICON_CHECKMARK + '</span> <span>Real-time availability</span></div>');
            }
        }
    };

    if (is_mounted) {
        pikaday_options.numberOfMonths = 1;
        pikaday_options.bound = isDpBounded();
    }

    $(document)
        .off('bw-gp-changed')
        .on('bw-gp-changed', function() {
            repopulate_cancel_text(opts, selected_date);
        });
    
    cancel_button_el
        .off('click')
        .on('click', function(e) {
            e.preventDefault();
            cancel_full_text.toggleClass('bw-cancel-free-popup');
        })

    let pikaday = init_pikaday(pikaday_options);
    if (!pikaday || !datepicker_el.hasClass('pika-initialized')) {
        $(document)
            .off('bw-pikaday-loaded')
            .on('bw-pikaday-loaded', function() {
                pikaday = init_pikaday(pikaday_options);
            });
    }


    let gp_container_el = $('.bw-pickers__picker-col--gp', el);

    search_button_el
        .off('click')
        .on('click', function(e) {
            e.preventDefault();

            cancel_full_text.removeClass('bw-cancel-free-popup');

            if (gp_container_el.hasClass('ts-popup--showing')) {
                hide_popup($('.ts-popup', gp_container_el));
            }
            
            let date = datepicker_datestring(pikaday);
            if (date == '') {
                const default_dt = get_default_date(options.utc_offset);
                date = to_system_date(default_dt);
            }
            let selections = $.extend({
                start_time: date,
                tour_id: opts.filter_tour_id,
            }, get_guest_counts(gp_container_el), get_vessel_type(opts, widget_el));
            selections.is_charter = opts.is_charter ? opts.is_charter : 0;

            destroy_pikaday(pikaday);
            destroy_guestpicker();
            bw_events.on_submit(selections);
    });
    $(window).on('resize', function() {
        destroy_pikaday(pikaday);
        if (is_mounted) {
            pikaday_options.bound = isDpBounded();
        }
        pikaday = init_pikaday(pikaday_options);

        toggle_mobile_view(el, bwgp_id, is_compact, is_mounted);
    });

    toggle_mobile_view(el, bwgp_id, is_compact, is_mounted);

    if (is_compact && is_mounted) {
        widget_el.addClass('bw-mounted');

        const tv_sample = get_cache('ca-tv-v2-tour-' + options.filter_tour_id);
        const vessel_type = tv_sample ? tv_sample.vessel[0].vessel_type : 'catamaran'; // should never get here
        if (!tv_sample || (1000*tv_sample.start_timestamp) < Date.now()) {
            // we don't have any future trips bc this one is from the past
            widget_el.addClass('bw-no-trips');
            if (!tv_sample) {
                widget_el.addClass('bw-no-prices');
            }
        }

        let bad_weather_modal_id = 'bw-search-modal-bad-weather';
        setup_modal({
            html: MODAL_TEMPLATE.replace(/\[modal_id\]/g, bad_weather_modal_id),
            on_shown: function(e, params) {
                const html = get_tc_section('bad-weather', vessel_type);
                let modal_el = $('#'+bad_weather_modal_id);
                $('.bw-modal__content', modal_el).html(html);
                $('.bw-modal__container', modal_el).append(CLOSEX_MODAL_TEMPLATE);
                $('.bw-modal__footer', modal_el).empty();
            }
        });

        let cancel_free_modal_id = 'bw-search-modal-cancel-free';
        setup_modal({
            html: MODAL_TEMPLATE.replace(/\[modal_id\]/g, cancel_free_modal_id),
            on_shown: function(e, params) {
                const html = get_tc_section('cancel', vessel_type);
                const modal_el = $('#'+cancel_free_modal_id);
                $('.bw-modal__content', modal_el).html(html);
                $('.bw-modal__container', modal_el).append(CLOSEX_MODAL_TEMPLATE);
                $('.bw-modal__footer', modal_el).empty();
            }
        });
    }

    bw_events.on_loaded();

    repopulate_cancel_text(opts, selected_date);

    function repopulate_cancel_text(opts, date_str) {
        const cancel_opts = $.extend({}, opts, get_guest_counts(gp_container_el));
        let vessel_type = '';

        if (opts.filter_tour_id) {
            const tv_sample = get_cache('ca-tv-v2-tour-' + opts.filter_tour_id);
            if (tv_sample) {
                vessel_type = tv_sample.vessel[0].vessel_type;
            }
        }

        const cancel_text = get_cancel_text(cancel_opts, date_str, vessel_type);
        update_data_targets({cancel_text: cancel_text}, widget_el);
    }
}

// convert search params to url params
export const to_url_params = (search_params) => {
    const ret = {
        step: STEPS.search.name,
        start_time: search_params.start_time ? search_params.start_time : '',
        adult: search_params.adult,
        child: search_params.child,
        toddler: search_params.toddler,
        tour_id: search_params.tour_id ? search_params.tour_id : 0,
    }

    if (search_params.vessel_type) {
        ret.vessel_type = search_params.vessel_type;
    }

    return ret;


    function bw_guestpicker_id() {
        return opts.identifier + '-bwgp-widget'
    }
}

function set_datepicker_display(datepicker_display_el, start_datestring) {
    if (!datepicker_display_el) {
        return;
    }
    let str = 'Select date';
    if (start_datestring !== false) {
        let date = convertISOtoDate(start_datestring + ' 00:00:00');
        str = date.toLocaleDateString('en-US', { day: 'numeric', month: 'short' });
        datepicker_display_el.addClass('bw-picked');
    }
    datepicker_display_el.html(str);
}

function toggle_mobile_view(search_el, bwgp_id, is_compact, is_mounted) {
    let gp_container_el = $('.bw-pickers__picker-col--gp', search_el);
    if (gp_container_el.length == 0) {
        return;
    }

    let attachGP = $(window).outerWidth() < 768;
    const is_compact_mounted = is_compact && is_mounted;
    const is_compact_not_mounted = is_compact && !is_mounted;

    if (is_compact_mounted) {
        attachGP = isGPMountable();
    }
    if (attachGP) {
        // attach
        if (!gp_container_el.hasClass('bwgp-attached') && !is_compact_not_mounted) {
            let gp_el = $('#' + bwgp_id + ' .bwgp-widget__container');
            gp_container_el.append(gp_el);
            gp_container_el.addClass('bwgp-attached');
            gp_container_el.addClass('bwgp-widget bwgp-attached');
        }
    }
    else if (gp_container_el.hasClass('bwgp-attached')) {
        // detach
        let gp_el = $('.bwgp-widget__container', gp_container_el);
        $('#' + bwgp_id).append(gp_el);
        gp_container_el.removeClass('bwgp-widget bwgp-attached');
    }
    else if (gp_container_el.hasClass('ts-popup--showing')) {
        hide_popup($('.ts-popup', gp_container_el));
    }
}

function get_vessel_type(opts, widget_el) {
    if (!opts.is_charter) {
        return {};
    }
    let vals = [];
    $('input[name="vessel_type"]:checked', widget_el).each(function() {
        vals.push($(this).val());
    });
    return { vessel_type: vals.join(',') };
}

function isGPMountable() {
    return $(window).outerHeight() >= MIN_MOUNTED_HEIGHT_GP && $(window).outerWidth() >= MIN_MOUNTED_WINDOW_WIDTH;
}

// return true if datepicker should be a popup
function isDpBounded() {
    if ($(window).outerWidth() < MIN_MOUNTED_WINDOW_WIDTH) {
        return true;
    }
    if ($(window).outerHeight() < MIN_MOUNTED_HEIGHT_DP) {
        return true;
    }

    return false;
}